<template>
    <section v-if="dashboard && dashboard.length" class="section-center" v-loading="loading">
        <main>
            <el-container>
                <el-row :gutter="20" style="flex-grow: 1">
                    <el-col :span="+card.col" v-for="(card, i) in dashboard" :key="i">
                        <div :class="['card', card.card.split('_')[0]]">
                            <div class="card-header">
                                {{card.name}}
                            </div>

                            <div class="card-body">
                                <el-timeline v-if="card.card.includes('card-timeline')">
                                    <el-timeline-item
                                    v-for="(activity, index) in card.options"
                                    :key="index"
                                    :type="randomColor()"
                                    :timestamp="activity.timestamp">
                                    {{activity.content}}
                                    </el-timeline-item>
                                </el-timeline>
                                <template v-else>
                                    <div v-if="card.card.includes('card-chart')" class="chart-content">
                                        <div :id="card.card"></div>
                                    </div>
                                    <ul class="card-items">
                                        <li
                                        v-for="(option,o) in card.options"
                                        :key="`card_${i}_opt_${o}`"
                                        :style="{backgroundColor: option.color ? `${option.color}15` : ''}"
                                        @click="nuevaVentana(option)">
                                            <div class="card-icon" style="position: relative">
                                              <template>
                                                <img src="/DOOX.DESK/img/libro_neutro.svg" style="height: 140%"> <div class="card-name" style="position: absolute;top: 29%">
                                                {{option.icon}}
                                              </div>
                                              </template>
                                            </div>
                                            <p :style="{color: option.color}">{{option.name}}</p>
                                        </li>
                                    </ul>
                                </template>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-container>
        </main>
    </section>
</template>

<script>
import {
  getDashboard
} from '@/helpers/api'

import { mapMutations } from 'vuex'

export default {
  name: 'Dashboard',
  props: {
    id: String,
    ficha: Object,
    entidad: String,
    porlet: Object,
    currentAction: Object,
    reload: {
      type: Boolean,
      required: false,
      default: () => false
    },
    autoReload: {
      type: Boolean,
      required: false,
      default: () => false
    },
    visibleReload: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      loading: false,
      error: null,
      dashboard: null
    }
  },

  mounted () {
    this.getData()

    this.$emit('created')
  },
  methods: {
    async getData () {
      if (this.loading) return

      this.error = false
      this.table = null

      this.loading = true

      try {
        let resp = await getDashboard()
        // let resp = await (await fetch('/test_local/')).json()
        // console.log(resp)

        this.dashboard = resp.data.dashboard

        // Graficas
        this.initChartCircle()
        this.initChartBar()
      } catch (err) {
        this.error = true
      }

      this.loading = false
    },
    nuevaVentana (option) {
      // console.log('nuevaVentana')
      this.$emit('openWindow', option)
    },

    // Graficas
    initChartCircle () {
      var options = {
        series: [422, 186, 31, 1765],
        labels: ['Particular', 'Autónomo', 'AAPP', 'Empresa'],
        chart: {
          type: 'donut'
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      }
      setTimeout(() => {
        if (!document.querySelector('#card-chart_circle')) return
        var chart = new ApexCharts(document.querySelector('#card-chart_circle'), options)
        			chart.render()
      }, 200)
    },
    initChartBar () {
      var options = {
        series: [{
          name: 'Facturas',
          data: [21, 34, 45, 49, 52, 61, 73, 84, 87, 90, 92, 98]
        }],
        chart: {
          type: 'bar',
          height: 315
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        },
        yaxis: {
          title: {
            text: 'Nº de facturas'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + ' Facturas'
            }
          }
        }
      }

      setTimeout(() => {
        if (!document.querySelector('#card-chart_bar')) return
        var chart = new ApexCharts(document.querySelector('#card-chart_bar'), options)
        			chart.render()
      }, 200)
    },
    randomColor () {
      let colors = ['primary', 'success', 'danger', 'warning', 'info']
      return colors[(Math.floor(Math.random() * 5) + 1) - 1]
    },

    refresh () {
      this.getData()
    }
  }
}
</script>

<style lang="scss">
.section-center {
    overflow: scroll;
    overflow-x: hidden;
    height: 100%;
    width: 100%;
    background-color: #edeff3;

    main {
        flex-grow: 1;
        padding: 15px 20px;
        section {
            margin-bottom: 10px;

            > p {
                font-size: 1.1rem;
                color: #646464;
                font-weight: 300;
                margin-bottom: 8px;
                margin-top: 0px;
            }
            > ul {
                list-style: none;
                padding: 0px;
                display: flex;
                flex-flow: wrap;
                margin: 0px;
                > li {
                    width: 100px;
                    min-width: 100px;
                    margin-right: 5px;
                    margin-bottom: 5px;
                }
            }

            // CARD DASHBOARD
            .card {
                position: relative;
                box-shadow: 0 2px 4px rgba(0,0,0,.15);
                background-color: white;
                border-radius: 6px;
                margin-bottom: 20px;
                .card-header {
                    padding: 25px 25px 0px 25px;
                    font-weight: 600;
                    font-size: 17px;
                }
                .card-body {
                    ul.card-items {
                        list-style: none;
                        padding: 0px;
                        margin: 0px;
                        > li:hover {
                            box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;
                            transition-duration: 200ms;
                        }
                    }
                }
                &.card-block {
                    .card-body {
                        padding: 15px 15px 5px 15px;
                        ul.card-items {
                            display: flex;
                            flex-wrap: wrap;
                            list-style: none;
                            padding: 0px;
                            margin: 0px;
                            > li {
                                width: calc((100% / 4) - 60px) !important;
                                display: flex;
                                flex-flow: column;
                                padding: 25px 20px 15px 20px;
                                margin: 0px 10px 20px 10px;
                                border-radius: 6px;
                                cursor: pointer;
                                background-color: #ff000017;
                                i {
                                    color: rebeccapurple;
                                    font-size: 30px;
                                    margin-bottom: 5px;
                                }
                                p {
                                    font-size: 16px;
                                    font-weight: 600;
                                    margin: 0px;
                                }
                            }
                        }
                    }
                }
                &.card-list {
                    .card-body {
                        padding: 25px 15px 5px 15px;
                        ul.card-items {
                            display: flex;
                            flex-wrap: wrap;
                            flex-flow: column;
                            > li {
                                display: flex;
                                flex-flow: row;
                                align-items: center;
                                margin: 0px 10px 20px 10px;
                                border-radius: 6px;
                                cursor: pointer;
                                background-color: transparent!important;
                                .card-icon {
                                    width: 40px;
                                    height: 40px;
                                    background-color: #e4e4e4;
                                    border-radius: 6px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    font-size: 20px;
                                    i {
                                        color: rebeccapurple;
                                    }
                                }
                                p {
                                    font-size: 16px;
                                    margin: 0px 0px 0px 15px;
                                    color: #303133!important;
                                }
                            }
                        }
                    }
                }
                &.card-timeline {
                    .card-body {
                        padding-top: 25px;
                    }
                }
                &.card-chart {
                    .card-body {
                        .chart-content {
                            padding: 10px 20px 15px 25px;
                        }
                        ul.card-items {
                            display: flex;
                            flex-wrap: wrap;
                            list-style: none;
                            padding: 0px;
                            margin: 0px;
                            > li {
                                width: calc((100% / 2) - 40px) !important;
                                display: flex;
                                flex-flow: row;
                                align-items: center;
                                padding: 15px 15px 15px 15px;
                                margin: 0px 5px 10px 5px;
                                border-radius: 6px;
                                cursor: pointer;
                                background-color: #b5b5b517;
                                i {
                                    color: rebeccapurple;
                                }
                                p {
                                    font-size: 16px;
                                    //font-weight: 600;
                                    margin: 0px 0px 0px 15px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
